import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { containerActions } from './actions';

import success from './images/success.svg';
import './styles.scss';

// const Notification = () => ;

class Notification extends React.Component {
  componentWillReceiveProps (nextProps) {
    if (nextProps.opened) {
      setTimeout(() => {
        this.props.callback();
        this.props.hideNotification();
      }, 1500);
    }
  }

  render() {
    const {
      title, status, opened
    } = this.props;

    return opened && (
      <div className={`notification ${status ? '-success' : '-failed'}`}>
        {/* <button
          onClick={() => {
          hideNotification();
          callback();
        }}
          className="notification-back"
        >
          Back
      </button> */}
        <div className="notification-wrapper">
          <p className="notification-title">
            {title}
          </p>
          { status ? <img src={success} alt="success" /> : null }
        </div>
      </div>
    );
  }
}

Notification.defaultProps = {
  title: '',
  status: true
};

Notification.propTypes = {
  title: PropTypes.string,
  status: PropTypes.bool,
  opened: PropTypes.bool.isRequired,
  hideNotification: PropTypes.func.isRequired,
  callback: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  opened: state.notification.opened,
  title: state.notification.title,
  status: state.notification.status,
  callback: state.notification.callback
});

export default connect(mapStateToProps, containerActions)(Notification);



// WEBPACK FOOTER //
// ./src/components/Notification/index.js